import {
  REPORT_GET_LOGO,
  REPORT_GET_REPORTS,
  REPORT_GET_STATE,
  REPORT_GET_SUBREPORT_CURRENT_PAGE,
  REPORT_GET_SUBREPORT_PAGES,
  REPORT_GET_SUBTITLE,
  REPORT_GET_TITLE
} from './types';

export const getters = {
  [REPORT_GET_TITLE]: state => {
    return state.report.title;
  },

  [REPORT_GET_SUBTITLE]: state => {
    return state.report.subtitle;
  },

  [REPORT_GET_REPORTS]: (state) => {
    return state.report.reports;
  },

  [REPORT_GET_STATE]: state => {
    return state.report;
  },

  [REPORT_GET_LOGO]: (state) => {
    return state.report.logo;
  },

  [REPORT_GET_SUBREPORT_PAGES]: (state) => {
    return state.report.subReportPages;
  },

  [REPORT_GET_SUBREPORT_CURRENT_PAGE]: (state) => {
    return state.report.subReportCurrentPage;
  }
};
